import React from "react";
import { ThemeProvider } from "@/hooks/use-theme";
import { SmoothScrollProvider } from "@/components/layout/smooth-scroll";

export function RootProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <SmoothScrollProvider>{children}</SmoothScrollProvider>
    </ThemeProvider>
  );
}
